import React from 'react';
import { Card, Col, Row, Statistic, Tooltip } from 'antd';
import { ArrowUpOutlined, CheckOutlined, CloseOutlined, ExclamationCircleOutlined, BugOutlined } from '@ant-design/icons';

const ResultTodayCounts = ({ getCounts = {} }) => {
    const totalChecked = getCounts.total_checked || 0;

    const calculatePercentage = (value) => {
        if (totalChecked === 0) return '0.0%'; 
        const percentage = (value / totalChecked) * 100;
        return `${percentage.toFixed(1)}%`;
    };

    const metrics = [
        {
            label: 'Checked',
            value: totalChecked,
            icon: <ArrowUpOutlined />,
            color: 'blue',
        },
        {
            label: 'Passed',
            value: getCounts.total_passed || 0,
            icon: <CheckOutlined />,
            color: 'green',
            percentage: calculatePercentage(getCounts.total_passed || 0),
        },
        {
            label: 'Rejected',
            value: getCounts.total_rejected || 0,
            icon: <CloseOutlined />,
            color: 'red',
            percentage: calculatePercentage(getCounts.total_rejected || 0),
        },
        {
            label: 'Defects',
            value: getCounts.total_defects || 0,
            icon: <BugOutlined />,
            color: 'purple',
            suffix: 'Nos.',
            percentage: calculatePercentage(getCounts.total_defects || 0),
        },
        {
            label: 'Defective Garments',
            value: getCounts.total_defective || 0,
            icon: <ExclamationCircleOutlined />,
            color: 'orange',
            forceSingleLine: true,
            percentage: calculatePercentage(getCounts.total_defective || 0),
        },
    ];

    return (
        <Card size="small">
            <Row gutter={10} justify="space-between">
                {metrics.map(({ label, value, icon, color, forceSingleLine, suffix = 'Pieces', percentage }) => (
                    <Col key={label} span={4} className="text-center">
                        <>
                            <Tooltip title={label}>
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 4,
                                        flexWrap: forceSingleLine ? 'nowrap' : 'wrap',
                                        whiteSpace: forceSingleLine ? 'nowrap' : 'normal',
                                    }}
                                >
                                    <span>{icon}</span>
                                    <span
                                        style={{
                                            fontSize: '14px',
                                            color: 'gray',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                        }}
                                    >
                                        {label}
                                    </span>
                                </div>
                            </Tooltip>
                            <Statistic
                                value={value}
                                valueStyle={{ color }}
                                suffix={suffix} 
                                className="mb-2"
                            />
                            <span
                                style={{
                                    fontSize: '14px',
                                    color: 'gray',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                }}
                            >
                                {percentage} 
                            </span>
                        </>
                    </Col>
                ))}
            </Row>
        </Card>
    );
};

export default ResultTodayCounts;